// src/pages/Services.jsx
import React from "react";
import ServicesHeroSection from "../components/service/ServicesHeroSection";
import ServicesPricingSection from "../components/service/ServicesPricingSection";
import ServicesCTASection from "../components/service/ServicesCTASection";

const Services = () => {
  const pageStyle = {
    paddingTop: "100px",
    minHeight: "100vh",
  };

  return (
    <div style={pageStyle}>
      <ServicesHeroSection />
      <ServicesPricingSection />
      <ServicesCTASection />
    </div>
  );
};

export default Services;
